import { render, staticRenderFns } from "./CCNode.vue?vue&type=template&id=050e67ec&scoped=true&"
import script from "./CCNode.vue?vue&type=script&lang=js&"
export * from "./CCNode.vue?vue&type=script&lang=js&"
import style0 from "./CCNode.vue?vue&type=style&index=0&id=050e67ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e67ec",
  null
  
)

export default component.exports